import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, 
        {
          path: '/case',
          name: 'case',
          component: resolve => require(['@/view/case'], resolve),
          meta: {
            title: '案例'
          }
        },
        {
          path: '/caseDetail',
          name: 'caseDetail',
          component: resolve => require(['@/view/caseDetail'], resolve),
          meta: {
            title: '案例详情'
          }
        },
        {
          path: '/DecorationKnowledge',
          name: 'DecorationKnowledge',
          component: resolve => require(['@/view/DecorationKnowledge'], resolve),
          meta: {
            title: '装修知识'
          }
        },
        {
          path: '/KnowledgeDetail',
          name: 'KnowledgeDetail',
          component: resolve => require(['@/view/KnowledgeDetail'], resolve),
          meta: {
            title: '知识详情'
          }
        },
        {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          }
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '关于我们'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {       //添加该方法
    return { x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js